export default __webpack_public_path__ + "static/media/animation-arrow21.d2214c32.gif";